import { render, staticRenderFns } from "./UiAvatar.vue?vue&type=template&id=9c0b85c4&"
import script from "./UiAvatar.vue?vue&type=script&lang=js&"
export * from "./UiAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UiAvatar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports